import React, { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'
import Icon from 'srcReact/components/icons/Icon'
import Badge from 'srcReact/components/common2/Badge'
import { useDispatch, useSelector } from 'react-redux'
import MemberImages from 'srcReact/components/common2/MemberImages'
import Popup from 'reactjs-popup'
import MessengerMobile from 'srcReact/MessengerPage/MessengerMobile'
import IconButton from 'srcReact/components/common2/IconButton'
import AnchorLink from 'srcReact/components/common2/AnchorLink'
import { messengerActions } from 'srcReact/MessengerPage/actions'
import { messengerSettings } from 'srcReact/MessengerPage/MessengerSettings'
import useInterval from 'srcReact/helpers/hooks/useInterval'
import usePrevious from 'srcReact/helpers/hooks/usePrevious'

function QuickMessenger(props) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const {
    organization: {
      current_organization,
      header: { messenger }
    },
    messenger: { filterItem }
  } = useSelector((state) => state)
  const [isMessengerOpen, setIsMessengerOpen] = useState(false)
  const [conversationId, setConversationId] = useState(0)
  const [isCloseConvButtonVisible, setIsCloseConvButtonVisible] = useState(false)
  const quickMessengerWrapperRef = useRef(null)

  useInterval(() => {
    if (current_organization?.info?.id > 0 && isMessengerOpen && conversationId === 0) {
      dispatch(messengerActions.getConversationsCheckUpdates(current_organization.info.id))
    }
  }, messengerSettings.REFRESH_INTERVAL)

  useEffect(() => {
    if (current_organization?.info?.id > 0) {
      dispatch(messengerActions.getConversationsList(current_organization.info.id, 1, filterItem))
    }
  }, [filterItem])
  const previousConversationId = usePrevious(conversationId)
  const toggleMessenger = (conversationId = 0) => {
    setConversationId(conversationId)
    if (conversationId > 0 && previousConversationId !== conversationId) {
      //if conversation window in open
      setIsMessengerOpen(true)
      dispatch(messengerActions.showSidebar(false))
      dispatch(messengerActions.showMainContent(true))
    } else {
      //if conversation list is open
      setIsMessengerOpen(!isMessengerOpen)
      dispatch(messengerActions.showSidebar(true))
      dispatch(messengerActions.showMainContent(false))
    }
  }

  const collapseMessenger = () => {
    quickMessengerWrapperRef?.current?.focus()
    setIsMessengerOpen(false)
    setConversationId(0)
  }

  const hideConversation = (conversationId) => {
    dispatch(messengerActions.hideConversation(conversationId))
  }

  const showCloseButton = () => {
    setIsCloseConvButtonVisible(true)
  }
  const hideCloseButton = () => {
    setIsCloseConvButtonVisible(false)
  }

  return (
    <div
      className={styles.quickMessengerWrapper}
      tabIndex={0}
      ref={quickMessengerWrapperRef}
      aria-label={t('formlabel.messengerNotificationCount', { count: messenger?.unread_count })}>
      {messenger?.recent_conversations?.length > 0 && (
        <div className={`${styles.unreadConvWrapper} ${isMessengerOpen && styles.unreadConvWrapperShifted}`}>
          {messenger?.recent_conversations.map((conv) => {
            return (
              <div className={styles.memberImageWrapper} onMouseEnter={showCloseButton} onMouseLeave={hideCloseButton}>
                <MemberImages
                  imgSizeSingle='small'
                  imgSizeDouble='tiny'
                  imgSizeMore='tiny'
                  imgSingleCss={styles.oneImageCSS}
                  imgDoubleCss={styles.twoImageCSS}
                  imgMoreCss={styles.moreImageCSS}
                  displayCount={3}
                  conversationName={conv?.conversation?.user_conversation_name}
                  from='quick-messenger'
                  handleOpenPopin={() => toggleMessenger(conv.id)}
                  members={conv.users.filter((u) => !u.is_logged_user)}
                />
                {conv.unread_count > 0 ? (
                  <Badge customCss={styles.convUnreadCount} size='small' color='green' text={conv.unread_count} />
                ) : isCloseConvButtonVisible ? (
                  <IconButton
                    aria-label={t('messenger.header.hideConversation')}
                    iconName='close24'
                    className={styles.btnClose}
                    iconSize='medium'
                    onClick={() => hideConversation(conv.id)}
                  />
                ) : null}
              </div>
            )
          })}
        </div>
      )}
      {!isMessengerOpen && (
        <button type='button' className={styles.btnCollapsed} onClick={() => toggleMessenger(0)}>
          {messenger?.unread_count > 0 && (
            <Badge customCss={styles.bdgTotalNotification} size='small' color='green' text={messenger?.unread_count} />
          )}

          <Icon name='chat24' size='large32' styleModifier={styles.chatIcon} />

          <span className={styles.text}>{t('messenger.chats')} </span>
          <Icon name='chevron-up24' size='large24' />
        </button>
      )}

      <div className={`${styles.quickMessengerModalWrapper} ${isMessengerOpen ? styles.show : styles.hide}`}>
        {isMessengerOpen && (
          <React.Fragment>
            {conversationId === 0 && (
              <div className={styles.header}>
                <IconButton
                  aria-label={t('messenger.collapseMessenger')}
                  iconName='chevron-down24'
                  iconSize='large24'
                  className={styles.btnCollapse}
                  onClick={collapseMessenger}
                />
                <h2 className={styles.title}>{t('messenger.yourChats')}</h2>
                <AnchorLink
                  isReactLink={false}
                  path={`/0/messenger`}
                  className={styles.link}
                  aria-label={t('formlabel.gotoMessenger')}>
                  <Icon name='chat24' size='large24' />
                  <Icon name='arrow-right' size='large24' />
                </AnchorLink>
              </div>
            )}

            <MessengerMobile
              fromFeed={false}
              fromQuickMessenger={true}
              conversationId={conversationId}
              setConversationId={setConversationId}
              isExpanded={conversationId === 0}
              closeMessengerPopup={collapseMessenger}
            />
          </React.Fragment>
        )}
      </div>
    </div>
  )
}

export default QuickMessenger
